<i18n>
  {
    "cl": {
      "localeIndicator":"UF",
      "hello": "Hola",
      "lastNewsMessage": "Encuentra aquí las últimas noticias sobre Creditú",
      "ownedSince": "Dueño de tu 🏡 desde hace",
    "ownedSinceDays": "Dueño de tu 🏡 desde este mes!",
    "ownedSinceSME": "Financiando tu 🚀 desde hace",
    "ownedSinceDaysSME": "Financiando tu 🚀 desde este mes!",
    "ownedSinceParking": "Financiando tu 🅿️ desde hace",
    "ownedSinceDaysParking": "Financiando tu 🅿️ desde este mes!",
    "singleYear": " año",
    "pluralYear": " años",
    "singleMonth": " mes",
    "pluralMonth": " meses",
    "and": " y "
    },
    "br": {
      "localeIndicator":"IPCA",
      "hello": "Oi",
      "lastNewsMessage": "Encontre aqui as últimas notícias sobre Creditú"
    },
    "pe": {
      "localeIndicator":"UF",
      "hello": "Hola",
      "lastNewsMessage": "Encuentra aquí las últimas noticias sobre Creditú"
    }
  }
</i18n>

<template>
  <div id="dashboard-container">
    <div class="is-flex is-flex-wrap-wrap">
      <iframe src="https://lottie.host/embed/0286bf2e-3fe9-41d8-b2bf-31980e4f7f00/2l7cMPA4xO.json" width="200" class="mr-4" />
      <div class="is-flex is-flex-direction-column">
        <h1>
          <span class="is-size-2 has-text-primary has-text-weight-medium">{{ $t('hello') }} </span>
          <span class="is-size-2">{{ $store?.state?.currentUser?.user?.name || '' }}!</span>
        </h1>
        <span v-if="$store?.state?.currentUser?.user?.rol === 'CLIENT'">
          <p v-if="welcomeDate.type === 'MORTGAGE'" class="has-text-grey">
            {{ welcomeDate.years === false && welcomeDate.months === false ? $t('ownedSinceDays') : $t('ownedSince') }}
            {{ welcomeDate.years && welcomeDate.years == 1 ? welcomeDate.years + $t('singleYear') : welcomeDate.years === false ? ''
              : welcomeDate.years + $t('pluralYear') }}{{ welcomeDate.years !== false && welcomeDate.months !== false ? $t('and') : '' }}
            {{ welcomeDate.months && welcomeDate.months == 1 ? welcomeDate.months + $t('singleMonth') : welcomeDate.months === false ? ''
              : welcomeDate.months + $t('pluralMonth') }}
          </p>
          <p v-else-if="welcomeDate.type === 'SME'" class="has-text-grey">
            {{ welcomeDate.years === false && welcomeDate.months === false ? $t('ownedSinceDaysSME') : $t('ownedSinceSME') }}
            {{ welcomeDate.years && welcomeDate.years == 1 ? welcomeDate.years + $t('singleYear') : welcomeDate.years === false ? ''
              : welcomeDate.years + $t('pluralYear') }}{{ welcomeDate.years !== false && welcomeDate.months !== false ? $t('and') : '' }}
            {{ welcomeDate.months && welcomeDate.months == 1 ? welcomeDate.months + $t('singleMonth') : welcomeDate.months === false ? ''
              : welcomeDate.months + $t('pluralMonth') }}
          </p>
          <p v-else-if="welcomeDate.type === 'PARKING'" class="has-text-grey">
            {{ welcomeDate.years === false && welcomeDate.months === false ? $t('ownedSinceDaysParking') : $t('ownedSinceParking') }}
            {{ welcomeDate.years && welcomeDate.years == 1 ? welcomeDate.years + $t('singleYear') : welcomeDate.years === false ? ''
              : welcomeDate.years + $t('pluralYear') }}{{ welcomeDate.years !== false && welcomeDate.months !== false ? $t('and') : '' }}
            {{ welcomeDate.months && welcomeDate.months == 1 ? welcomeDate.months + $t('singleMonth') : welcomeDate.months === false ? ''
              : welcomeDate.months + $t('pluralMonth') }}
          </p>
        </span>
        <p v-else class="has-text-grey">{{ $t('lastNewsMessage') }}</p>
      </div>
    </div>
    <div class="columns is-multiline mt-4">
      <div class="column is-4-widescreen is-full">
        <div v-if="$i18n.locale == 'br'" class="card-item">
          <span class="is-flex is-align-items-center">
            <span class="icon-item is-flex is-align-items-center is-justify-content-center">
              <i class="fa-regular fa-calendar has-text-primary is-size-5" />
            </span>
            <span>
              <h4 class="has-text-grey is-size-6">{{ formattedTodayDate }}</h4>
            </span>
          </span>
        </div>
        <div v-else class="card-item">
          <span class="is-flex">
            <span class="icon-item is-flex is-align-items-center is-justify-content-center">
              <i class="fa-regular fa-calendar has-text-primary is-size-5" />
            </span>
            <span>
              <h4 class="has-text-grey has-text-weight-medium is-size-6">{{ formattedTodayDate }}</h4>
            </span>
          </span>
        </div>
      </div>
      <div class="column is-3-widescreen is-full">
        <div v-if="$i18n.locale !== 'pe'" class="card-item">
          <span class="is-flex">
            <span class="icon-item is-flex is-align-items-center is-justify-content-center">
              <p class="has-text-primary has-text-weight-semibold">{{ $t('localeIndicator') }}</p>
            </span>
            <span>
              <h4 v-if="$i18n.locale == 'br'" class="has-text-grey has-text-weight-medium is-size-6">{{ indicators.ipca }}</h4>
              <h4 v-if="$i18n.locale == 'cl'" class="has-text-grey has-text-weight-medium is-size-6">{{ `$${setValueToFormatted(indicators.uf, 'currencyNumber')}` }}</h4>
            </span>
          </span>
        </div>
      </div>
      <div v-if="$store?.state?.currentUser?.user?.rol === 'CLIENT'" class="column">
        <div>
          <CreditResume
            :show-resume="true" />
        </div>
      </div>
      <div v-else class="column">
        <div>
          <product-doings />
        </div>
      </div>
    </div>
    <!-- <div>
      <h2>Dashboard</h2>
      <div class="box date-filter">
        <dashboard-filter @dashboard-range-date-change="onChangeRangeDate" />
      </div>
      <div id="data-container" :class="{ 'columns is-multiline is-mobile is-centered m-0' : screenBreakPoint, 'columns is-multiline is-mobile is-left m-0' : !screenBreakPoint}">
        <dashboard-credipay-card v-if="checkUserFeature('element.dashboard.card.credipay')" id="dashboard-credipay-card" :start="sDate" :end="eDate" />
        <dashboard-servipag-card v-if="checkUserFeature('element.dashboard.card.servipag')" id="dashboard-servipag-card" :start="sDate" :end="eDate" />
        <dashboard-funnel-card v-if="checkUserFeature('element.dashboard.card.funnel')" id="dashboard-funnel-card" :start="sDate" :end="eDate" />
        <dashboard-simulator-card v-if="checkUserFeature('element.dashboard.card.simulator')" id="dashboard-simulator-card" :start="sDate" :end="eDate" />
        <dashboard-ITG-card v-if="checkUserFeature('element.dashboard.card.itg')" id="dashboard-itg-card" :start="sDate" :end="eDate" />
        <dashboard-users-track-use v-if="checkUserFeature('element.dashboard.card.user-track-use')" id="dashboard-user-track-use" :start="sDate" :end="eDate" />
        <dashboard-users-track-time v-if="checkUserFeature('element.dashboard.card.user-track-time')" id="dashboard-user-track-time" :start="sDate" :end="eDate" />
        <dashboard-investor-track v-if="checkUserFeature('element.dashboard.card.investor-time')" id="dashboard-investor-time" :start="sDate" :end="eDate" />
        <dashboard-indicators-card v-if="checkUserFeature('element.dashboard.card.indicators')" id="dashboard-indicators-card" :start="sDate" :end="eDate" />
      </div>
    </div> -->
  </div>
</template>

<script>
// import DashboardFilter from '@/ui/components/internal/dashboard/DashboardFilter.vue';
// import DashboardCredipayCard from '@/ui/components/internal/dashboard/DashboardCredipayCard.vue';
// import DashboardSimulatorCard from '@/ui/components/internal/dashboard/DashboardSimulatorCard.vue';
// import DashboardServipagCard from '@/ui/components/internal/dashboard/DashboardServipagCard.vue';
// import DashboardFunnelCard from '@/ui/components/internal/dashboard/DashboardFunnelCard.vue';
// import DashboardITGCard from '@/ui/components/internal/dashboard/DashboardITGCard.vue';
// import DashboardUsersTrackUse from '@/ui/components/internal/dashboard/users-track/UsersTrackUse.vue';
// import DashboardUsersTrackTime from '@/ui/components/internal/dashboard/users-track/UsersTrackTime.vue';
// import DashboardInvestorTrack from '@/ui/components/internal/dashboard/users-track/InvestorTrack.vue';
// import DashboardIndicatorsCard from '@/ui/components/internal/dashboard/DashboardIndicatorsCard.vue';
import userFeatures from '@/ui/mixins/user-features';
import ProductDoings from '@/ui/components/internal/ProductDoings.vue';
import CreditResume from '@/ui/components/internal/credit-resume/CreditResume.vue';
import { valueToFormatted } from 'creditu-types/format';
import { getUf, getIpca } from '@/application/services/api-clients/indicators';
import { getClientResumeByClientId } from '@/application/services/api-clients/clients';

// const startDateIndex = 0;
// const endDateIndex = 1;

export default {
  components: {
    // DashboardFilter,
    // DashboardCredipayCard,
    // DashboardSimulatorCard,
    // DashboardServipagCard,
    // DashboardFunnelCard,
    // DashboardITGCard,
    // DashboardUsersTrackUse,
    // DashboardUsersTrackTime,
    // DashboardInvestorTrack,
    // DashboardIndicatorsCard,
    ProductDoings,
    CreditResume
  },
  mixins: [userFeatures],
  data() {
    return {
      // dates: [],
      // sDate: new Date(new Date().setDate(1)),
      // eDate: new Date(),
      formattedTodayDate: '',
      formatedSecondaryCurrencyFactor: '',
      WindowWidth: window.innerWidth,
      indicators: {},
      clientDataResume: [],
      welcomeDate: '',
      today: new Date(),
      formatter: new Intl.NumberFormat('de-DE')
    };
  },
  computed: {
    screenBreakPoint() {
      return this.WindowWidth < 1250;
    }
  },
  async created() {
    let clientData;
    try {
      clientData = await getClientResumeByClientId(this.$store.state.currentUser.user.clientId);
      this.clientDataResume = await clientData;
      this.welcomeDate = await this.welcomeTime();
    } catch (_error) {
      this.alert({ message: this.$t('errorMessage') });
    }
  },
  async mounted() {
    // this.isLoading = false;
    window.addEventListener('resize', this.handleResize);
    this.getFormattedTodayDate();
    await this.loadData();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // async onChangeRangeDate(event) {
    //   this.dates = event;
    //   this.sDate = this.dates[startDateIndex];
    //   this.eDate = this.dates[endDateIndex];
    // },
    handleResize() {
      this.WindowWidth = window.innerWidth;
    },
    getFormattedTodayDate() {
      const todayDate = new Date();
      const formatOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      if (this.$i18n.locale === 'br') {
        this.formattedTodayDate = new Intl.DateTimeFormat('pt-BR', formatOptions).format(todayDate);
      } else {
        this.formattedTodayDate = new Intl.DateTimeFormat('es-ES', formatOptions).format(todayDate);
      }
    },
    async loadData() {
      if (!this.$router.history.current.params.indicators) {
        const uf = await getUf();
        const ipca = await getIpca();
        this.indicators = { uf, ipca };
      } else {
        this.indicators = this.$router.history.current.params.indicators;
      }
    },
    setValueToFormatted(value, type) {
      return valueToFormatted(type, this.$i18n.locale, value);
    },
    welcomeTime() {
      const clientSignatureDate = this.clientDataResume[0].signatureDate;
      const elapsedTime = this.today - new Date(clientSignatureDate);
      const months = 86400000 * 30.416666666666668; // cantidad de segundos en un mes * un promedio de dias al mes
      const elapsedMonths = Math.floor(elapsedTime / months);
      const resultYears = Math.floor(elapsedMonths / 12);
      const resultMonths = elapsedMonths - (12 * resultYears);
      return {
        months: resultMonths >= 1 ? resultMonths : false,
        years: resultYears >= 1 ? resultYears : false,
        type: this.clientDataResume[0].creditType
      };
    }
  }
};
</script>

<style scoped>
#dashboard-container {
  margin-top: 2rem;
  overflow: visible !important;
}

#data-container {
  margin-top: 2rem;
}

.date-filter {
  display: grid;
  grid-template-columns: repeat( auto-fit, minmax(8rem, 1fr));
  gap: 2rem;
}

</style>
